import React from 'react';
interface SwitchProps {
  checked: boolean;
  label: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}
export function Switch({
  checked,
  label,
  disabled = false,
  onChange
}: SwitchProps) {
  return <span className="inline-flex items-center gap-2" data-id="element-875" data-mp="2tvcdsk7iniwq">
      <button type="button" role="switch" aria-checked={checked} aria-label={label} disabled={disabled} onClick={() => onChange?.(!checked)} className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sf-blue focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60 ${checked ? 'border-sf-blue bg-sf-blue' : 'border-[#AEAEAE] bg-[#C9C9C9]'}`} data-id="element-876" data-mp="2oxu0khmguhix">
        <span className={`h-4 w-4 rounded-full bg-white shadow transition-transform duration-150 ease-out ${checked ? 'translate-x-4' : 'translate-x-0.5'}`} data-id="element-877" data-mp="1if5ivyy8mh86" />
      </button>
      <span className={`text-xs font-semibold ${checked ? 'text-sf-text' : 'text-sf-weak'}`} data-id="element-878" data-mp="2wbpbxdkpzjhm">{checked ? 'On' : 'Off'}</span>
    </span>;
}